// extracted by mini-css-extract-plugin
export default {"card_header":"CardHeader_card_header__TuDtT","title":"CardHeader_title__I1FdS"};